import React from "react";
import { Button } from "../ui/button";
import { cn } from "../ui/utils";
import { ArrowLeft } from "lucide-react";

interface HubHeaderProps {
  onGoHome: () => void;
  title?: string;
  subtitle?: string;
  centerSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
  className?: string;
}

export default function HubHeader({
  onGoHome,
  title = "Traveler's Hub",
  subtitle = "Public Directory",
  centerSlot,
  rightSlot,
  className,
}: HubHeaderProps) {
  return (
    <header
      className={cn(
        "border-b border-blue-200/30 p-4 shadow-lg",
        className
      )}
      style={{ backgroundColor: "#003c5d" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-3 items-center">
          {/* Brand + back to Home */}
          <button
            type="button"
            onClick={onGoHome}
            title="Back to Home"
            className="flex items-center group select-none focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-400 rounded-md cursor-pointer"
            style={{ background: "transparent" }}
          >
            <div className="text-white text-left">
              <h1 className="text-xl font-medium group-hover:underline">{title}</h1>
                <div className="flex items-center gap-2 text-ss text-white/80">
                <span>Powered by</span>
                <img
                  src="/travelin-logo.svg"
                  alt="Travelin"
                  className="h-4 w-auto rounded-sm bg-white px-1 py-0.5"
                />
              </div>
            </div>
          </button>

          {/* Optional center content (e.g., filters or tabs) */}
          <div className="flex items-center justify-center gap-2 min-h-10">
            {centerSlot}
          </div>

          {/* Right side slot (optional) */}
          <div className="flex items-center justify-end gap-3">
            {rightSlot}
          </div>
        </div>
      </div>
    </header>
  );
}
